import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Palette, Loader2 } from 'lucide-react';

export default function BrandKitTab({ brandKit, setBrandKit, loading, onSave }) {
  return (
    <Card className="bg-white border-gray-border">
      <CardHeader>
        <CardTitle className="text-lg font-heading flex items-center gap-2">
          <Palette className="h-5 w-5 text-emerald-brand" />
          Brand Kit
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Primary Color</Label>
            <div className="flex items-center gap-2 mt-2">
              <input type="color" value={brandKit.primary_color} onChange={(e) => setBrandKit(prev => ({ ...prev, primary_color: e.target.value }))} className="w-10 h-10 rounded border cursor-pointer" />
              <Input value={brandKit.primary_color} onChange={(e) => setBrandKit(prev => ({ ...prev, primary_color: e.target.value }))} className="flex-1" />
            </div>
          </div>
          <div>
            <Label>Secondary Color</Label>
            <div className="flex items-center gap-2 mt-2">
              <input type="color" value={brandKit.secondary_color} onChange={(e) => setBrandKit(prev => ({ ...prev, secondary_color: e.target.value }))} className="w-10 h-10 rounded border cursor-pointer" />
              <Input value={brandKit.secondary_color} onChange={(e) => setBrandKit(prev => ({ ...prev, secondary_color: e.target.value }))} className="flex-1" />
            </div>
          </div>
        </div>
        <div>
          <Label>Tone</Label>
          <Select value={brandKit.tone} onValueChange={(val) => setBrandKit(prev => ({ ...prev, tone: val }))}>
            <SelectTrigger className="mt-2"><SelectValue placeholder="Select tone" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="professional">Professional</SelectItem>
              <SelectItem value="friendly">Friendly</SelectItem>
              <SelectItem value="bold">Bold</SelectItem>
              <SelectItem value="educational">Educational</SelectItem>
              <SelectItem value="luxury">Luxury</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Brand Voice</Label>
          <Textarea placeholder="Describe your brand voice and personality..." value={brandKit.brand_voice} onChange={(e) => setBrandKit(prev => ({ ...prev, brand_voice: e.target.value }))} className="mt-2 min-h-[100px]" />
        </div>
        <Button onClick={onSave} disabled={loading} className="bg-emerald-brand hover:bg-emerald-hover">
          {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
          Save Brand Kit
        </Button>
      </CardContent>
    </Card>
  );
}
